// Need to add check for what domain we are on, for now all is on playground
export const LOCAL_OR_PLAYGROUND = !process.env.REACT_APP_PRODUCTION

export const isLocalhost = /local|localhost/.test(window.location.hostname)

const isPrPlayground = () => {
  const hostname = window.location.hostname

  return prPlaygrounds.some(pgUrl => hostname.includes(pgUrl))
}
const prPlaygrounds = [
  'writing-playground.easybib.com',
  'writing-playground.bibme.org',
  'writing-playground.citationmachine.net',
  'writing.dev.cheggnet.com',
  'local.writing.test.cheggnet.com',
  'local.writing.citationmachine.net',
  'local.writing.easybib.com',
  'local.writing.bibme.org',
]

export const PRPLAYGROUND_OR_LOCAL =
  typeof window !== 'undefined' && (isLocalhost || isPrPlayground())



// WEBPACK FOOTER //
// ./src/utils/localOrPlayground.ts